import { UserCategory } from '@educare/shared';

export const sharedConstants = {
  navigation: [
    {
      routerLink: ['dashboard'],
      label: 'navigationMenu.home',
      iconClass: 'das das-dashboard',
      key: 'dashboard',
      exact: true,
      isVisible: () => true
    },
    {
      routerLink: ['cme'],
      label: 'navigationMenu.myCME',
      iconClass: 'das das-cme',
      key: 'cme',
      isVisible: (category: any) => {
        return [UserCategory.Physician, UserCategory.Nurse, UserCategory.AlliedHealth, UserCategory.MidWife].includes(
          category
        );
      }
    },
    {
      routerLink: ['events'],
      label: 'navigationMenu.events',
      iconClass: 'das das-edc-dob',
      key: 'events',
      isVisible: () => true
    },
    {
      routerLink: ['profile-settings'],
      label: 'navigationMenu.myProfile',
      iconClass: 'das das-my-profile1',
      key: 'profile-settings',
      isVisible: () => true
    }
  ],
  header: {
    isProfileClickable: true
  }
};
